import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { IoIosCloseCircleOutline } from "react-icons/io";

const StripeProPlanPayment = ({
  id,
  amount,
  currency,
  isOpen,
  onClose,
  onPaymentSuccess,
  planType, // "Pro Plan"
}) => {
  const [clientSecret, setClientSecret] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userEmail, setUserEmail] = useState("");

  // useEffect(() => {
  //   // Load Stripe (test key for now)
  //   const promise = loadStripe(
  //     "pk_test_51RjwCNH4SEOW1T3dMgaqKZwCHyUcSceyurYaPwcqjWrOEpLNK56QsBsBOxCHvBZZINHy0H6bnN2w2PN0svXmyTFT00EBj8nalv"
  //   );
  //   setStripePromise(promise);
  // }, []);

  useEffect(() => {
    // Load Stripe only on the client side
    const promise = loadStripe(
      "pk_live_51RjwCNH4SEOW1T3d8NbnBAfQFvuPQjXVIlqDEuAiKXkAnjk1opYg86mCJdU6aikNOisXhwyADFh9VRq6Ue9r88gi00HTySzJLr"
    );
    setStripePromise(promise);
  }, []);
  
  useEffect(() => {
    const createProSeekerSubscription = async () => {
      console.log("=== StripeProSeekerPayment useEffect triggered ===");
      console.log("isOpen:", isOpen);
      console.log("planType:", planType);

      // Get user email and name from localStorage
      const email = localStorage.getItem("email") || "";
      setUserEmail(email);
      let userName =
        localStorage.getItem("name") ||
        localStorage.getItem("username") ||
        localStorage.getItem("Username") ||
        "";

      // If username is still empty, try to get it from email (use part before @)
      if (!userName && email) {
        userName = email.split("@")[0];
      }

      console.log(
        "Retrieved from localStorage - email:",
        email,
        "username:",
        userName
      );
      console.log("All localStorage keys:", Object.keys(localStorage));

      if (!email) {
        setError(
          "User email is required for Pro Seeker subscription. Please log in again."
        );
        setLoading(false);
        return;
      }

      if (!userName) {
        setError(
          "User name is required for Pro Seeker subscription. Please log in again."
        );
        setLoading(false);
        return;
      }

      console.log("Creating Pro Plan subscription for:", { email, userName });

      // Build payload for Pro Seeker subscription API
      const subscriptionBody = {
        Email: email,
        CustomerName: userName,
        MonthlyProPlanPriceId: "price_1Sa9jnH4SEOW1T3dVhvFCtnd", // Monthly $3.99 Pro Plan
      };

      try {
        setLoading(true);
        setError(null);

        console.log("Creating Pro Seeker subscription with:", {
          Email: email,
          CustomerName: userName,
          MonthlyProSeekerPriceId: subscriptionBody.MonthlyProSeekerPriceId,
        });

        const response = await fetch(
          "https://xianhefairy.com/LotusFairy_API/Payment/CreateProPlanMonthlySubscription",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(subscriptionBody),
          }
        );

        console.log(
          "API Response Status:",
          response.status,
          response.statusText
        );

        if (!response.ok) {
          let txt = "";
          try {
            txt = await response.text();
            console.error("API Error Response Body:", txt);
          } catch (e) {
            txt = `<unable to read response body: ${e.message}>`;
          }
          console.error(
            "CreateProSeekerMonthlySubscription failed",
            response.status,
            txt
          );
          throw new Error("Failed to create Pro Seeker subscription: " + txt);
        }

        const data = await response.json();
        console.log("CreateProSeekerMonthlySubscription response:", data);
        console.log("Response structure:", JSON.stringify(data, null, 2));

        // The API should return subscription info with clientSecret
        let clientSecretValue = null;
        let subscriptionId = null;

        if (data.subscription && data.subscription.clientSecret) {
          clientSecretValue = data.subscription.clientSecret;
          subscriptionId = data.subscription.id;

          console.log("Client secret found:", clientSecretValue);
          console.log("Subscription ID:", subscriptionId);

          setClientSecret(clientSecretValue);
          setSubscriptionData({
            id: subscriptionId,
            status: data.subscription.status || "active",
            // capture Stripe customer id if backend returned it
            stripeCustomer: data.subscription.customer || data.customer || "",
          });
        } else {
          console.error("Response data keys:", Object.keys(data));
          if (data.subscription) {
            console.error("subscription keys:", Object.keys(data.subscription));
          }
          throw new Error(
            "No subscription client secret found in API response. Expected structure: { subscription: { clientSecret, id, status } }"
          );
        }
      } catch (error) {
        console.error("Error creating Pro Seeker subscription:", error);
        setError(`Error: ${error.message}. Check browser console for details.`);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      createProSeekerSubscription();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, amount, currency, planType]);

  const appearance = {
    theme: "stripe",
  };

  const handleProPlanPaymentSuccess = (paymentIntent) => {
    // When the client confirms payment successfully, persist the
    // subscription to our backend so it's tied to the customer.
    (async () => {
      try {
        // Determine success: payment intent succeeded or subscription is active
        const piStatus = paymentIntent && paymentIntent.status;
        const subStatus = subscriptionData && subscriptionData.status;

        const isPaymentSucceeded =
          (piStatus &&
            (piStatus === "succeeded" || piStatus === "processing")) ||
          (subStatus && subStatus === "active");

        if (!isPaymentSucceeded) {
          console.warn(
            "Payment not in succeeded/active state, skipping save.",
            { piStatus, subStatus }
          );
        } else {
          try {
            const localUserId = localStorage.getItem("userID") || "";
            const saveBody = {
              CUST_ID: Number(localUserId) || 0,
              // Prefer the PaymentIntent id (pi_...) when available, otherwise
              // fall back to the returned Stripe customer id or subscription id.
              STRIPE_ID:
                (paymentIntent && paymentIntent.id) ||
                (subscriptionData &&
                  (subscriptionData.stripeCustomer || subscriptionData.id)) ||
                "",
              SUB_ID: (subscriptionData && subscriptionData.id) || "",
              SUB_DESC: planType || "Pro Seeker",
              AMOUNT: amount || 0,
              REF_CODE: "", // <-- Referral code being sent
              CREATED_BY: userEmail || "test",
              UPDATED_BY: userEmail || "test",
            };

            console.log(
              "🔵 [PRO SEEKER] Saving subscription to backend (post-confirmation):",
              saveBody
            );
            console.log("🔵 [PRO SEEKER] Payment Intent Status:", piStatus);
            console.log("🔵 [PRO SEEKER] Subscription Status:", subStatus);

            const saveResp = await fetch(
              "https://xianhefairy.com/LotusFairy_API/Payment/SaveStripeSubscription",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(saveBody),
              }
            );

            console.log(
              "🔵 [PRO SEEKER] SaveStripeSubscription API Response Status:",
              saveResp.status,
              saveResp.statusText
            );

            if (!saveResp.ok) {
              console.error(
                "🔴 [PRO SEEKER] SaveStripeSubscription FAILED! Status:",
                saveResp.status
              );
            } else {
              console.log("✅ [PRO SEEKER] SaveStripeSubscription SUCCESS!");
            }
            const saveText = await saveResp.text();
            try {
              const parsed = saveText ? JSON.parse(saveText) : null;
              console.log(
                "SaveStripeSubscription response:",
                parsed ?? saveText
              );
            } catch (e) {
              console.log("SaveStripeSubscription response (text):", saveText);
            }
          } catch (e) {
            console.error(
              "🔴 [PRO SEEKER] EXCEPTION saving subscription to backend:",
              e
            );
            console.error("🔴 [PRO SEEKER] Error details:", e.message, e.stack);
          }
        }
      } finally {
        // Always forward the success event to parent so UI updates as before
        try {
          onPaymentSuccess({
            paymentIntent,
            subscription: subscriptionData,
          });
        } catch (e) {
          console.error("onPaymentSuccess handler error:", e);
        }
      }
    })();
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 9998,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "white",
          borderRadius: 12,
          padding: 16,
          boxShadow: "0px 4px 16px rgba(0,0,0,0.3)",
          display: "flex",
          flexDirection: "column",
          width: "min(98vw, 640px)",
          maxWidth: "98vw",
          maxHeight: "calc(100vh - 32px)",
          overflow: "hidden",
          zIndex: 9999,
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          <button
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "24px",
              color: "black",
            }}
            onClick={onClose}
          >
            <IoIosCloseCircleOutline />
          </button>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: "auto",
            paddingRight: 0,
            display: "block",
            width: "100%",
          }}
        >
          {loading ? (
            <p>Loading Pro Seeker subscription payment...</p>
          ) : error ? (
            <div
              style={{
                color: error.includes("Note:") ? "#ff9800" : "white",
                padding: "20px",
              }}
            >
              <h3>{error.includes("Note:") ? "Information" : "Error"}</h3>
              <p>{error}</p>
              {!error.includes("Note:") && (
                <button
                  onClick={onClose}
                  style={{
                    marginTop: "10px",
                    padding: "8px 16px",
                    backgroundColor: "#333",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Close
                </button>
              )}
            </div>
          ) : clientSecret && stripePromise ? (
            <Elements
              stripe={stripePromise}
              options={{ 
                          clientSecret, 
                          appearance,
                          layout: {
                            type: 'accordion',
                            defaultCollapsed: true,
                            radios: false,
                            spacedAccordionItems: false
                          }
                        }}
            >
              <CheckoutForm
                onClose={onClose}
                onPaymentSuccess={handleProPlanPaymentSuccess}
              />
            </Elements>
          ) : (
            <p>
              Unable to initialize Pro Seeker subscription payment. Please try
              again later.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StripeProPlanPayment;
